import React from 'react';

function NotificationIcon({ iconClass }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="#ff0000" stroke='currentColor' strokeWidth={1} width='1em' height='1em' viewBox="-2 -2 48.43 48.43" className={iconClass}><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M22.21,0A22.22,22.22,0,1,0,44.43,22.21,22.23,22.23,0,0,0,22.21,0Zm0,36.94a2.34,2.34,0,1,1,2.34-2.34A2.33,2.33,0,0,1,22.21,36.94Zm3-26L23.13,28a.92.92,0,0,1-.92.82.94.94,0,0,1-.92-.82l-2.1-17a3,3,0,0,1,5.3-2.39A3.06,3.06,0,0,1,25.24,10.91Z" /></g></g></svg>
    );
}

export default NotificationIcon;